import React, { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { ReactComponent as Undo } from "../../../icons/undo.svg";
import { CgsTitle } from "../components";
import { TabSwitcher } from "../CGS_Dashboard";
import Hamburger from "../../../components/Hamburger";
import { ReactComponent as GNAiIcon } from "../../../icons/gnai_logo.svg";
import { PageHeader } from "../../../components/Page";
import CreateNewSessionModal from "./Resource/Popup/CreateSessionPopup";
import {
  resolveMeritPageFromSessionPayload,
  unwrapModSessionPayload,
  useMeritEngineNavigation,
} from "./useMeritEngineNavigation";
import Tooltip from "../../../components/tooltip";
import { getModSession } from "../Utility/RestApi";
import { useDispatch } from "react-redux";
import { ModCSPDCLSelectedDate } from "../../../store/state/ModCSPDCL/ModDate";
import { setModCSPDCLSession } from "../../../store/state/ModCSPDCL/ModSession";
import { setModCSPDCLVersion } from "../../../store/state/ModCSPDCL/ModVersion";
import { setModCSPDCLSessionToken } from "../../../store/state/ModCSPDCL/ModSessionToken";

export default function GridcoMod() {
  const [isModalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { navigateToPage } = useMeritEngineNavigation();
  const dispatch = useDispatch();

  const GotoPreviousStage = async () => {
    setLoading(true);
    try {
      const res = await getModSession();
      const payload = unwrapModSessionPayload(res);

      if (Object.keys(payload).length > 0) {
        if (typeof payload.date === "string") {
          dispatch(ModCSPDCLSelectedDate(payload.date));
        }
        if (payload.session !== undefined && payload.session !== null) {
          dispatch(setModCSPDCLSession(payload.session as any));
        }
        if (payload.version !== undefined && payload.version !== null) {
          dispatch(setModCSPDCLVersion(payload.version as any));
        }
        if (
          payload.session_token !== undefined &&
          payload.session_token !== null
        ) {
          dispatch(setModCSPDCLSessionToken(payload.session_token as any));
        }

        const page = resolveMeritPageFromSessionPayload(payload);
        if (page) {
          navigateToPage(page);
        } else {
          alert("Error in continue to previous Session");
        }
      } else {
        alert("Error in continue to previous Session");
      }
    } catch {
      alert("Error in continue to previous Session");
    } finally {
      setLoading(false);
    }
  };

  const GotoArchivePage = () => {
    navigateToPage("archive");
  };

  return (
    <>
      <div className="w-full">
        <PageHeader
          leftComponent={
            <div className="flex items-center gap-5">
              <GNAiIcon width={80} />
              <Hamburger />
              <TabSwitcher />
              <h5 className="text-[18px] text-[#6F6D7C] font-medium">
                MeritEngine
              </h5>
            </div>
          }
          middleComponent={<CgsTitle />}
        />
        <div className="tabContent">
          {" "}
          <div className="h-[calc(-90px+100vh)] p-4">
            <div className="w-full h-full">
              <div className="meritEngine w-full h-full flex flex-col items-center justify-center px-4 rounded-xl relative bg-mod bg-bottom bg-no-repeat bg-cover">
                <div className=" ">
                  <div className="text-center !my-20">
                    <h1 className="text-5xl  font-semibold text-[#F1935C] tracking-wider">
                      MeritEngine
                    </h1>

                    <h2 className="text-5xl font-semibold text-[#525062] mt-8 tracking-wider">
                      Instant Merit Order Dispatch:
                    </h2>

                    <p className="text-[#525062] font-normal mt-4 text-4xl tracking-wider">
                      Intelligent, Seamless, and Insightful
                    </p>

                    <p className="text-[#F1935C] font-semibold mt-6 text-3xl tracking-wide">
                      Powered by{" "}
                      <span className="text-[#F1935C] font-bold">GNA</span>
                      <span className="text-[#6F6D7C]">i</span>
                    </p>

                    {/* Buttons */}
                    <div className="flex gap-10 justify-center !mt-16 flex-wrap">
                      <button
                        onClick={() => setModalOpen(true)}
                        className="flex items-center gap-1 text-lg rounded-2xl px-5 py-3 bg-[#F1935C] shadow-lg text-[#fff] font-medium border border-[#F1935C] hover transition transform hover:scale-105"
                      >
                        <Plus className="w-6 h-6" />
                        <span>Create a New Session</span>
                      </button>
                      <button
                        onClick={GotoPreviousStage}
                        className="flex items-center gap-1 text-lg rounded-2xl px-5 py-3 bg-[#FFFAF6] text-[#F1935C] font-medium border border-[#F1935C] hover transition transform hover:scale-105"
                      >
                        {loading ? (
                          <span>Loading...</span>
                        ) : (
                          <span>Continue to Previous Session</span>
                        )}
                      </button>
                    </div>

                    {/* Archive link */}
                    <div className="flex items-center justify-center mt-8">
                      <button
                        onClick={GotoArchivePage}
                        className="flex items-center gap-2 px-7 py-5 text-lg  border-[#34656D] bg-transprent text-[#34656D] font-medium"
                      >
                        <Undo className="w-5 h-5" />
                        Go to Archive
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <CreateNewSessionModal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
              />
            </div>
          </div>
          <div className="gna-footer-container">
            <div className="grid grid-cols-2 justify-between gap-5 ">
              {/* <p className="gna-footer-text"> </p> */}

              <p className="gna-footer-text col-span-1 text-start">
                Powered by <strong>GNA Energy</strong>
              </p>
              <strong className="gna-footer-text col-span-1 text-end">
                Beta Version
              </strong>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
